module.exports = __webpack_public_path__ + "img/gdpr-lg-grey.39562d3d.png";